module.exports = __webpack_public_path__ + "static/flashcard_1-122ef2952082607961e3ee65922a566a.jpg";